import { useEffect, useState } from 'react';
import { Button, Stack, styled, Grid, Typography, Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import MainCard from 'ui-component/cards/MainCard';
import { AddCircleOutline } from '@mui/icons-material';
import ParametersLegality from './ParametersLegality';
import CreatingLegality from './CreatingLegality';
import { useDispatch, useSelector } from 'react-redux';
import { createRules, getAssignmentRules } from 'services/RulesService';
import { RulesCondition, RulesObjects } from 'types/assignmentrules';
import { SET_RULES_DATA, SET_RULES_DATA_CONDITION, SET_RULES_LEGALITY_VALUE, SET_VALUE } from 'store/slices/rules';
import { set } from 'lodash';

const ButtonIconStyle = styled(Button)({
    '&:hover': {
        border: 'none'
    },
    border: 'none',
    padding: '12px, 16px, 12px, 16px',
    fontSize: '14px',
    fontWeight: 500
});

function RulesPage() {
    const [disabledSave, setDisabledSave] = useState(true);
    const intl = useIntl();
    const [success, setSuccess] = useState(false);
    const [status, setStatus] = useState<boolean>();
    const [assignmentRules, setAssignmentRules] = useState<RulesCondition[]>([]);
    const [assignmentRulesCondition, setAssignmentRulesConditionData] = useState<RulesObjects[]>([]);
    const [apicall, setApicall] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { id } = useParams();
    const rules_formula = useSelector((state: any) => state.rules.data);
    const rules_condition = useSelector((state: any) => state.rules.rulesData);

    const navigate = useNavigate();
    const submitHandler = async () => {
        const updatedRulesConditionData = rules_condition.map((item: any) => {
            const updatedConditions = item.condition.map((condition: any) => {
                const matchedRule = rules_formula.find((rule: { unique_id: any }) => rule.unique_id === condition.rule_unique_id);
                return {
                    ...condition,
                    label: matchedRule?.equation_label || condition.label // fallback to existing label if not found
                };
            });

            return {
                ...item,
                condition: updatedConditions
            };
        });

        if (!apicall) {
            const obj: any = {};
            obj.assignment_id = id;
            obj.rule_data = rules_formula;
            obj.rule_condition_data = updatedRulesConditionData;
            createRules(obj, setSuccess, setApicall).then(() => {
                // getAssignmentRulesData();
                navigate('/assignments');
            });
            // setApicall(true);
        }
    };

    const getAssignmentRulesData = () => {
        getAssignmentRules(id, setAssignmentRules, setAssignmentRulesConditionData, setStatus).then((resp: any) => {
            if (status == true) {
                dispatch({
                    type: SET_RULES_DATA,
                    payload: assignmentRules
                });
                dispatch({
                    type: SET_RULES_DATA,
                    payload: assignmentRules
                });
                dispatch({
                    type: SET_RULES_LEGALITY_VALUE,
                    payload: assignmentRulesCondition
                });
                dispatch({
                    type: SET_RULES_DATA_CONDITION,
                    payload: assignmentRulesCondition
                });
                dispatch({
                    type: SET_VALUE,
                    payload: assignmentRules
                });
            }
        });
    };
    useEffect(() => {
        getAssignmentRulesData();
    }, [id, status == true]);

    return (
        <>
            <MainCard
                title={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FormattedMessage id="adding-legality" />
                        <Typography sx={{ fontWeight: '400', fontSize: '12px', lineHeight: '20px', color: '#878E95' }}>
                            <FormattedMessage id="assignment-name-title" />
                        </Typography>
                    </Box>
                }
                sx={{ position: 'relative', minHeight: 'calc(100vh - 200px)' }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} md={9}>
                        <ParametersLegality />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <CreatingLegality />
                    </Grid>
                </Grid>

                <Stack direction="row" marginTop={11} justifyContent="space-between">
                    <ButtonIconStyle color="secondary" onClick={() => navigate(-1)} variant="outlined" startIcon={<ArrowForwardIcon />}>
                        <FormattedMessage id="back" />
                    </ButtonIconStyle>
                    <Button
                        onClick={submitHandler}
                        size="medium"
                        variant="contained"
                        color="secondary"
                        disabled={rules_condition.length == 0 || rules_formula.length == 0}
                    >
                        <FormattedMessage id="save" />
                    </Button>
                </Stack>
            </MainCard>
        </>
    );
}

export default RulesPage;
